// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"d436f769","185":"bbea04c0","218":"d1b4ed1c","272":"95af5459","282":"ea7d02ec","293":"f38127ab","411":"84210bd1","527":"aae3088e","598":"0223622b","635":"51698f0a","779":"92e4ac5d","873":"35c62e54"}[chunkId] + ".chunk.js";
};